import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SysLimiters } from '@core/limiters/limiters.model';
import { AbstractForm } from '@root/abstract/form';
import { AccountModeType } from '@shared/components/account-mode-switcher/account-mode-switcher.component';
import { PATTERN_EMAIL } from '@shared/constants';


export enum LoginFormField {
    Code = 'code',
    Phone = 'phone',
    Email = 'email',
    Password = 'password',
}

export interface LoginFormModel {
    [LoginFormField.Code]: FormControl<string | null>;
    [LoginFormField.Phone]: FormControl<string | null>;
    [LoginFormField.Email]: FormControl<string | null>;
    [LoginFormField.Password]: FormControl<string | null>;
}

@Injectable()
export class LoginFormService extends AbstractForm<LoginFormField, LoginFormModel> {
    public createReactiveForm(): FormGroup<LoginFormModel> {
        this.build({
            [LoginFormField.Code]: new FormControl<string | null>(null, [Validators.required]),
            [LoginFormField.Phone]: new FormControl<string | null>(null, [Validators.required]),
            [LoginFormField.Email]: new FormControl<string | null>(null, [Validators.required, Validators.pattern(PATTERN_EMAIL)]),
            [LoginFormField.Password]: new FormControl<string | null>(null, [
                Validators.required,
                Validators.minLength(SysLimiters.PasswordMinLength),
            ]),
        });

        return this.form;
    }

    public setLoginMode(mode: AccountModeType): void {
        if (mode === AccountModeType.Phone) {
            this.getControlByPath(LoginFormField.Phone).enable();
            this.getControlByPath(LoginFormField.Email).disable();
        } else if (mode === AccountModeType.Email) {
            this.getControlByPath(LoginFormField.Phone).disable();
            this.getControlByPath(LoginFormField.Email).enable();
        }

        this.form.updateValueAndValidity();
    }
}
